import React from 'react';

export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 612 612">
        <path d="M598.221,531.586l-110.58-110.542c30.314-43.443,48.228-96.149,48.228-153.105c0-147.976-119.958-267.934-267.934-267.934S0,119.963,0,267.939s119.958,267.934,267.934,267.934     c56.956,0,109.662-17.913,153.105-48.228l110.542,110.542c18.411,18.41,48.229,18.41,66.64,0     C616.593,579.814,616.593,549.997,598.221,531.586z M267.934,459.32c-105.681,0-191.381-85.7-191.381-191.381     c0-105.681,85.701-191.381,191.381-191.381c105.681,0,191.381,85.701,191.381,191.381C459.315,373.62,373.615,459.32,267.934,459.32z" />
    </svg>
);
